module.exports = __webpack_public_path__ + "26b049255e5cd785501b44091beef270.png";